import {
  type IMediaLibDialogItem,
  MediaLibPresetEnum,
  useMediaLibDialogStoreShallow,
} from "@editor/modules/media-lib";
import { useMediaLibDialogCtx } from "@editor/modules/media-lib/ctx";
import { prepBlurhashUrl } from "@/shared/utils";
import { Stock } from "../../stock-images";
import type { IImagesPanelImage } from "../../stock-images/types";

export const MediaDialogStockImages = () => {
  const { isMultiSelect, onSelect, preset } = useMediaLibDialogCtx();
  const { toggleSelectedItem, selectedItems } = useMediaLibDialogStoreShallow(
    (s) => ({
      selectedItems: s.selectedItems,
      toggleSelectedItem: s.toggleSelectedItem,
    }),
  );

  const handleClick = (image: IImagesPanelImage) => {
    if (preset === MediaLibPresetEnum.OnlyVideos) return;
    let url = image.url;
    if (image.imageBlurhash) url = prepBlurhashUrl(url, image.imageBlurhash);
    const item: IMediaLibDialogItem = {
      id: image.id,
      url,
      type: "image",
      mediaFrom: "stock-image",
      shouldUpload: true,
    };

    if (!isMultiSelect) return onSelect(item);
    toggleSelectedItem(item);
  };

  return (
    <Stock
      view="dialog"
      onSelect={handleClick}
      selectedItems={selectedItems}
      isMultiSelect={isMultiSelect}
    />
  );
};
